export default "__VITE_ASSET__C1$YR0oK__"